(() => {
  const initAccountNavSwiper = (root = document) => {
    if (!root.querySelector('[data-account-nav-swiper]')) return;
    if (typeof Swiper === 'undefined') {
      window.loadSwiper().then(() => initAccountNavSwiper(root));
      return;
    }

    root.querySelectorAll('[data-account-nav-swiper]').forEach((swiperEl) => {
      if (swiperEl.swiper || swiperEl.dataset.swiperInitialized === 'true') return;
      swiperEl.dataset.swiperInitialized = 'true';

      const instance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        watchOverflow: true,
        simulateTouch: true,
        grabCursor: true,
        mousewheel: { forceToAxis: true, releaseOnEdges: true },
      });

      // The row is display:none above 1200px (desktop nav takes over), so a swiper
      // constructed while hidden measures a zero-width container and never recovers
      // its slide widths on its own. Re-measure whenever the element's own box changes
      // size, which fires once it becomes visible again (e.g. resizing down to mobile).
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(() => instance.update()).observe(swiperEl);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAccountNavSwiper());
  window.addEventListener('load', () => initAccountNavSwiper());
  window.addEventListener('resize', () => initAccountNavSwiper());
  document.addEventListener('shopify:section:load', (event) => initAccountNavSwiper(event.target));
})();
